import React, { Component, useEffect, useState, useMemo, useCallback } from 'react'
import { connect } from 'react-redux'
import AcControl from './acControl'
import WindowTintControl from './WindowTintControl/index'
// import DemoAcControl from './demoAcControl'
import RoomTheme from "./RoomTheme"
import SoundControl from './SpeakerSelect'

import ACSelector from './ACSelector'
import RoundSlider from '../roundSlider'
import { changeValue } from '../roundSlider'
import {
    ACPower, setTempOfAC, setFanSpeedToLow,
    setFanSpeedToMedium, setFanSpeedToHigh,
    setFanSpeedToAuto, ecoMode, decrementTemp,
    incrementTemp, fanSpeedID, setFanSpeedToggle,
    zoneName,
    CLICKED,
    EXIT,
    CMSPath
} from '../../../../config/constant'
import {
    sendCommand, setPowerSwitch, TempChange,
    sendACCommand, setSelectedZone, restoreValue, setSelectedAC, sendAcCommand, getInncomRoomControlData, setAcSelected
} from '../../../../action/roomControlAction'
import { roomThemeColorConfig } from '../../../JS/colorConfig'
import DefaultImage from '../../../../images/defaultAsset/bg_room_temp.png'
import { scrollUpEffect, scrollDownEffect, removeScrollDown } from '../scrollEffect';
import $ from 'jquery';
import { scrollToTop } from '../../../../JS/scrollToTop'
import {setDNDon, setGoHome, setLoader, setMURon, setOpenDemoCamera, setOpenExternalLinkInSameTab} from '../../../action/homeAction'
import { guestDetails, sendAnalytics } from '../../../../action/homeAction'
import { calculateTimeDifference, getDefaultAnalyticsLabel } from '../../../JS/utility'
import { currentWidget, openSMSWidget, popupOpenClose, setDeviceConfigFailed, setFailScreen, setMobileTVPage, setMultiSubWidget, setOpenProfileImage, setRegPage } from '../../../../action/action'
import { nonCompWidgetClick } from '../../../JS/widgetHandling'
import { withTranslation } from 'react-i18next'
import { setRoomControlPage } from '../../../action/action'
import { closeOrderPopUp } from '../../../action/hCommerce2'


const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        currentWidget: state.store.sideNavBar.currentWidget,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        selectedZone: state.store.roomControl.selectedZone,
        celciusMax: state.store.InncomRoomControl.celciusMax,
        configs: state.store.InncomRoomControl.configs,
        currentFanSpeed: state.store.InncomRoomControl.currentFanSpeed,
        celciusMin: state.store.InncomRoomControl.celciusMin,
        farenheitMax: state.store.InncomRoomControl.farenheitMax,
        farenheitMin: state.store.InncomRoomControl.farenheitMin,
        currentAcTemp: state.store.InncomRoomControl.currentAcTemp,
        currentRoomTemp: state.store.InncomRoomControl.currentRoomTemp,
        powerSwitch: state.store.InncomRoomControl.selectedAC.powerSwitch,
        ecoMode: state.store.InncomRoomControl.selectedAC.ecoMode,
        seletedIndex: state.store.roomControl.seletedIndex,
        currentWidgets: state.store.sideNavBar.currentWidget,
        zoneCount: state.store.roomControl.zoneCount,
        VDAZoneList: state.store.roomControl.VDAZoneList,
        hvac: state.store.InncomRoomControl.hvac,
        menuColor: state.store.home.MenuColor,
        selectedAC: state.store.InncomRoomControl?
        state.store.InncomRoomControl.selectedAC : [] ,
        acSelected: state.store.acSelected,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        appLauncherWidget: state.store.appLauncher.widget,
        DND: state.store.InncomRoomControl.DND?
        state.store.InncomRoomControl.DND: null,
        MUR: state.store.InncomRoomControl.MUR?
        state.store.InncomRoomControl.MUR: null,
        streamingUrlFromConfig: state.store.home.clientConfig.doorCameraFeed ?
            state.store.home.clientConfig.doorCameraFeed.doorCameraFeedUrl : null,
        menuColor: state.store.home.MenuColor,
        currentHomePage: state.store2.currentHomePage,
        survey: state.store.survey,
        externalSignIn: state.store2.externalSignIn,
        roomControlSpecificVersion: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.roomControlSpecificVersion,

    }
}

const mapDispatchToProps =
{
    // setRegPage,
    // VDAStatusApi,
    setPowerSwitch,
    sendCommand,
    TempChange,
    sendACCommand,
    setSelectedZone,
    restoreValue,
    setSelectedAC,
    sendAcCommand,
    getInncomRoomControlData,
    setAcSelected,
    setGoHome,
    sendAnalytics,
    setFailScreen,
    currentWidget,
    setMultiSubWidget,
    popupOpenClose,
    openSMSWidget,
    setOpenProfileImage,
    setRoomControlPage,
    setDeviceConfigFailed,
    setOpenDemoCamera,
    setRegPage,
    setDNDon,
    setMURon,
    sendAcCommand,
    closeOrderPopUp,
    setOpenExternalLinkInSameTab,
    setMobileTVPage,
    guestDetails,
    sendAnalytics,
    setGoHome,
    setLoader,
    setFailScreen,
  
}

export const PowerIcon=()=>{
    return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M8.0002 1.33334V8.00001M12.2669 4.40001C13.1046 5.23808 13.6755 6.30546 13.9074 7.46753C14.1393 8.62961 14.022 9.83434 13.5701 10.9298C13.1182 12.0253 12.3521 12.9624 11.3683 13.623C10.3846 14.2836 9.22722 14.6381 8.04223 14.6418C6.85725 14.6456 5.69769 14.2983 4.70981 13.6439C3.72192 12.9894 2.94994 12.0571 2.49123 10.9645C2.03251 9.87189 1.9076 8.66792 2.13224 7.50442C2.35689 6.34091 2.92103 5.26998 3.75353 4.42668" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>;
}

const Tabs = ({selectedTab, setTab, multiControllerWidgetsConfigs})=>{
    return multiControllerWidgetsConfigs &&
    <div class="tabs">

        { multiControllerWidgetsConfigs.tabs.map(tab=>{
            return <div class={`${selectedTab.tabTitle == tab.tabTitle && "selected"} tab`} onClick={()=>setTab(tab)}> {tab.tabTitle}</div>
        })}
    </div>

}

const SingleClickToggle=(props)=>{
    let widget={
        "displayName": props.type.toUpperCase(),
        "compName": props.type.toUpperCase(),
     }

    return <div >
        {props.type && 
            (props.type=="dnd")? "Do Not Disturb":
            (props.type=="mur")? "Make Up Room":""}
        <button onClick={()=>{nonCompWidgetClick(widget, props)}}>{<PowerIcon/>}</button>
    </div>
}

const SingleClickToggleProped = connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation('translations')(SingleClickToggle));

function MultiController (props) {
    const [selectedTab, setSelectedTab]= useState(null);
    const [configs, setConfigs]=useState(null);
    

    const mapControlItemToComponent = {
       'AcControl': <AcControl />,
       'roomTheme': <RoomTheme />,
       'speakerControl':<SoundControl/>,
       'windowTintControl': <WindowTintControl/>,
       "dnd":<div class="single-controller"><SingleClickToggleProped type={"dnd"}  /> </div>,
       "mur":<div class="single-controller"><SingleClickToggleProped type={"mur"}  /> </div>
    }

    const setTab=(tab)=>{
        setSelectedTab(tab)
    }

    const memoizedConfigs = useMemo(() => props.configs.multiControllerWidgetsConfigs, 
            [JSON.stringify(props.configs.multiControllerWidgetsConfigs)]
        );

    useEffect(()=>{
        let configs;
       
            configs= props.configs && props.configs.multiControllerWidgetsConfigs;

            
            setConfigs(configs)
            console.log("MultiController mounted", configs)
        
        console.log("MultiController mounted", configs)
        
        if(configs && configs.tabs) setSelectedTab(configs.tabs[0])
        scrollDownEffect(null,"header",props.menuColor,4);

    },[memoizedConfigs])


        return  <>
        <div class="multi-controller-container">
        {
            selectedTab &&
            <>
            <Tabs selectedTab={ selectedTab} setTab={setTab} multiControllerWidgetsConfigs={configs} /> 
    
            {  selectedTab.tabItems.map((tabItems)=>{
                console.log(tabItems, "tabItems")
                return mapControlItemToComponent[tabItems];
            })}
            </>

        
        }
             </div>
        </>
    
}


export default connect(
    mapStateToProps, mapDispatchToProps
)(withTranslation('translations')(MultiController));



